module.exports = __webpack_public_path__ + "3e382dc7e0778368866689c3c783045e.svg";